import { render, staticRenderFns } from "./CouponExtension.vue?vue&type=template&id=6b5d5010&scoped=true&"
import script from "./CouponExtension.vue?vue&type=script&lang=js&"
export * from "./CouponExtension.vue?vue&type=script&lang=js&"
import style0 from "./CouponExtension.vue?vue&type=style&index=0&id=6b5d5010&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5d5010",
  null
  
)

export default component.exports